/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

// 验收商品项列表
exports.getPurchReceiptGoodsItemList = function (data, callback) {// 验收商品项列表
    api.post('/receipt/goods/item/list/get')
    .data(data)
    .done(callback)
    .go();
};

// ================================= 工单验收单 =====================
// 工单验收单分页列表
exports.getServcWorkReceiptList = function (data, callback) {
    api.post('/receipt/servc/work/receipt/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取工单验收单信息
exports.getServcWorkReceiptInfo = function (params, callback) {
    api.get('/receipt/servc/work/receipt/info/get')
    .params(params)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/receipt.js
// module id = 207
// module chunks = 1